export const PROJECT_STATUSES = {
  DRAFT: 'draft',
  ACTIVE: 'active',
  COMPLETED: 'completed'
};

export const getStatusText = (status) => {
  return status.charAt(0).toUpperCase() + status.slice(1);
};

export const getStatusColor = (status) => {
  switch (status) {
    case PROJECT_STATUSES.DRAFT:
      return '#FEF3C7';
    case PROJECT_STATUSES.ACTIVE:
      return '#E6F4EA';
    case PROJECT_STATUSES.COMPLETED:
      return '#F3F4F6';
    default:
      return '#F3F4F6';
  }
};

export const getStatusTextColor = (status) => {
  switch (status) {
    case PROJECT_STATUSES.DRAFT:
      return '#92400E';
    case PROJECT_STATUSES.ACTIVE:
      return '#1E8E3E';
    case PROJECT_STATUSES.COMPLETED:
      return '#6B7280';
    default:
      return '#6B7280';
  }
}; 